// Compiled to assets/built/index.js by `npm run build`.
import "../css/index.css";

// Archive: every post renders inside its own year row so the page works without JS.
// Merge consecutive rows of the same year into one, so each year heading shows once.
function groupByYear() {
    let previous = null;
    document.querySelectorAll(".jp-year-row").forEach((row) => {
        if (previous && previous.dataset.year === row.dataset.year) {
            const target = previous.querySelector(".jp-year-posts");
            row.querySelectorAll(".jp-post").forEach((post) => target.appendChild(post));
            row.remove();
        } else {
            previous = row;
        }
    });
}

// Post: copy the post URL to the clipboard.
function copyLink() {
    document.querySelectorAll("[data-copy-link]").forEach((button) => {
        button.addEventListener("click", async () => {
            const label = button.querySelector("span");
            try {
                await navigator.clipboard.writeText(button.dataset.copyLink);
                label.textContent = "Copied";
            } catch {
                label.textContent = "Couldn't copy";
            }
            setTimeout(() => (label.textContent = "Copy link"), 2000);
        });
    });
}

groupByYear();
copyLink();
